<template>
  <div class="px-2">
    <b-card class="w-100 d-flex rounded-lg">
      <b-row
        align-h="between"
        align-v="center"
      >
        <b-col
          cols="12"
          md="4"
          lg="3"
        >
          <b-form-group
            label="Filter by Status"
            label-for="status-filter"
          >
            <b-form-select
              id="status-filter"
              v-model="statusFilter"
              :options="statusFilterOptions"
              @change="onStatusFilterChange"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="hasPermission('Create Institution')"
          cols="12"
          md="auto"
        >
          <b-button
            class="btn rounded-pill"
            variant="primary"
            @click="addInstitution()"
          >
            Create Institution
          </b-button>
        </b-col>
      </b-row>
      <center v-if="isLoading">
        <b-spinner
          variant="primary"
          label="Spinning"
        />
      </center>
      <b-row class="py-2">
        <center
          v-if="!isLoading && institutions.data && institutions.data.length === 0"
          class="w-100 text-center mr-3"
        >
          <h3>{{ getEmptyStateMessage() }}</h3>
        </center>
        <b-table
          v-if="!isLoading && institutions.data && institutions.data.length > 0"
          striped
          hover
          :items="institutions.data"
          :fields="fields"
        >
          <template #cell(name)="data">
            <b-link
              v-if="data.item.id"
              :to="{ name: 'institution_profile', params: { id: data.item.id } }"
              class="text-primary font-weight-bold"
            >
              {{ data.item.name }}
            </b-link>
            <span v-else>{{ data.item.name }}</span>
          </template>

          <template #cell(total_seats)="data">
            <div>
              {{ data.item.used_seats }}/{{ data.item.total_seats }}
            </div>
          </template>

          <template #head(consumed_tokens)="data">
            <span v-b-tooltip.hover.top="'Consumed Tokens / Maximum Tokens'">
              {{ data.label }}
            </span>
          </template>

          <template #cell(consumed_tokens)="data">
            <div>
              {{ data.item.consumed_tokens }}/{{ data.item.institution_max_token ? data.item.institution_max_token : '0' }}
            </div>
          </template>
          <template #cell(Actions)="data">
            <div class="d-flex justify-content-start align-items-center">
              <b-link
                :tooltip="'none'"
                class="alert-link cutom-alert-link mr-1"
                @click="showInstitution(data.item.id)"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Show'"
                  :tooltip="'none'"
                  icon="EyeIcon"
                  size="18"
                />
              </b-link>
              <b-link
                v-if="hasPermission('Update Institution')"
                :tooltip="'none'"
                class="alert-link cutom-alert-link mr-1"
                :to="{ name: 'edit_institution', params: { id: data.item.id} }"
              >
                <feather-icon
                  v-b-tooltip.hover.top="'Edit'"
                  :tooltip="'none'"
                  icon="EditIcon"
                  size="18"
                />
              </b-link>
              <!-- <b-link
                v-if="hasPermission('Delete Institution')"
                :tooltip="'none'"
                class="alert-link cutom-alert-link text-danger"
                @click="deleteInstitution(data.item.id)"
              >
                <feather-icon
                  :tooltip="'none'"
                  icon="Trash2Icon"
                  size="18"
                  v-b-tooltip.hover.top="'Delete'"
                />
              </b-link> -->
              <b-link
                v-if="hasPermission('Update Institution')"
                :tooltip="'none'"
                class="alert-link cutom-alert-link status-toggle-link"
                :class="(data.item.status === true || data.item.status === 1) ? 'status-active' : 'status-inactive'"
                :disabled="togglingStatus[data.item.id]"
                @click="toggleInstitutionStatus(data.item)"
              >
                <feather-icon
                  v-if="!togglingStatus[data.item.id]"
                  v-b-tooltip.hover.top="(data.item.status === true || data.item.status === 1) ? 'Active - Click to deactivate' : 'Inactive - Click to activate'"
                  :icon="(data.item.status === true || data.item.status === 1) ? 'CheckCircleIcon' : 'XCircleIcon'"
                  size="20"
                />
                <b-spinner
                  v-else
                  small
                  variant="primary"
                />
              </b-link>
              <span
                v-else
                class="status-badge"
                :class="(data.item.status === true || data.item.status === 1) ? 'status-active-badge' : 'status-inactive-badge'"
              >
                {{ (data.item.status === true || data.item.status === 1) ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </template>
        </b-table>
      </b-row>

      <!-- Pagination & Per Page -->
      <b-row class="mt-2 w-100 align-items-center" v-if="institutions && institutions.meta">
        <b-col md="4" class="text-light d-flex align-items-center" style="font-size: 0.95rem;">
          <span v-if="institutions.meta.total > 0" class="d-flex align-items-center" style="margin-left: 2px;">
            Showing 
            <b-form-select
              v-model="per_page"
              :options="[10, 25, 50, 100]"
              class="custom-per-page mx-1"
              @change="onPageChange(1)"
            />
          </span>
        </b-col>
        <b-col md="4" class="d-flex justify-content-center">
          <b-pagination
            v-model="institutions.meta.current_page"
            :total-rows="institutions.meta.total ? institutions.meta.total : 0"
            :per-page="institutions.meta.per_page ? institutions.meta.per_page : 0"
            @change="onPageChange"
            class="mb-0"
          />
        </b-col>
        <b-col md="4"></b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BSpinner,
  BContainer,
  BRow,
  BCol,
  BButton,
  BCard,
  BTable,
  VBTooltip,
  BLink,
  BPagination,
  BFormGroup,
  BFormSelect,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Institutions',
  components: {
    BLink,
    VBTooltip,
    BSpinner,
    BContainer,
    BTable,
    BRow,
    BCol,
    BButton,
    BCard,
    BPagination,
    BFormGroup,
    BFormSelect,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters({
      institutions: 'institutions/items',
    }),
  },
  data() {
    return {
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'expiry_date', label: 'Expiry Date', sortable: true },
        { key: 'total_seats', label: 'Total Seats', sortable: true },
        { key: 'students_code', label: 'Enrolment Code', sortable: true },
        { key: 'consumed_tokens', label: 'Consumed Tokens', sortable: true },
        'Actions',
      ],
      isLoading: false,
      togglingStatus: {}, // Track loading state for each institution
      statusFilter: null, // null = all, true = active, false = inactive
      statusFilterOptions: [
        { value: null, text: 'All' },
        { value: true, text: 'Active' },
        { value: false, text: 'Inactive' },
      ],
      per_page: 10,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    addInstitution() {
      this.$router.push({
        name: 'create_institution',
      })
    },
    init() {
      this.isLoading = true
      this.loadInstitutions()
    },
    loadInstitutions(page = null) {
      const query = {
        page: page || this.institutions?.meta?.current_page || 1,
        per_page: this.per_page,
      }

      // Only add status filter if it's not null
      if (this.statusFilter !== null) {
        query.status = this.statusFilter
      }

      this.$store
        .dispatch('institutions/list', query)
        .then(response => {
          this.isLoading = false
        })
        .catch(e => {
          this.isLoading = false
          console.log(e.response)
          this.$swal({
            icon: 'error',
            title: `<h4>Error fetching institution details: ${e.message}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        })
    },
    refresh() {
      this.loadInstitutions()
    },
    onPageChange(page) {
      // Update current page in institutions meta if it exists
      if (this.institutions && this.institutions.meta) {
        this.institutions.meta.current_page = page
      }
      this.loadInstitutions(page)
    },
    onStatusFilterChange() {
      // Reset to page 1 when filter changes
      if (this.institutions && this.institutions.meta) {
        this.institutions.meta.current_page = 1
      }
      this.loadInstitutions()
    },
    getEmptyStateMessage() {
      if (this.statusFilter === true) {
        return 'No active institutions found'
      } if (this.statusFilter === false) {
        return 'No inactive institutions found'
      }
      return 'No Data to show'
    },

    deleteInstitution(id) {
      this.$swal({
        title: '<h4>Are you sure you want to delete this institution?</h4>',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#7367f0',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
      }).then(result => {
        if (result.isConfirmed) {
          this.isLoading = true
          this.$store
            .dispatch('institutions/remove', id)
            .then(response => {
              this.isLoading = false
              this.refresh()
            })
            .catch(e => {
              this.$swal({
                icon: 'error',
                title: `<h4>Error removing institution: ${e.message}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            })
        } else {
          this.isLoading = false
        }
      })
    },

    showInstitution(id) {
      this.$router.push({
        name: 'institution_profile',
        params: { id },
      })
      this.$store
        .dispatch('institutions/get', id)
        .then(response => {
          this.isLoading = false
        })
        .catch(error => {
          this.$swal({
            icon: 'error',
            title: `<h4>Error fetching institution details: ${error}</h4>`,
            showConfirmButton: true,
            confirmButtonColor: '#7367f0',
            allowOutsideClick: true,
          })
        })
    },
    toggleInstitutionStatus(institution) {
      // Handle undefined/null status - default to false (inactive)
      const currentStatus = institution.status === true || institution.status === 1
      const action = currentStatus ? 'deactivate' : 'activate'
      const actionMessage = currentStatus
        ? 'Are you sure you want to deactivate this institution? Users will be blocked from accessing the system.'
        : 'Are you sure you want to activate this institution? Users will be able to access the system.'

      this.$swal({
        title: `<h4>${actionMessage}</h4>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#7367f0',
        cancelButtonColor: '#6c757d',
        confirmButtonText: `Yes, ${action} it!`,
        cancelButtonText: 'No, cancel!',
      }).then(result => {
        if (result.isConfirmed) {
          // Set loading state for this specific institution
          this.$set(this.togglingStatus, institution.id, true)

          const actionMethod = currentStatus ? 'deactivate' : 'activate'
          this.$store
            .dispatch(`institutions/${actionMethod}`, institution.id)
            .then(response => {
              this.$set(this.togglingStatus, institution.id, false)
              this.$swal({
                icon: 'success',
                title: `<h4>Institution ${action}d successfully!</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
              // Refresh the list to reflect the status change
              this.refresh()
            })
            .catch(error => {
              this.$set(this.togglingStatus, institution.id, false)
              const errorMessage = error.response?.data?.message
                || error.message
                || `Failed to ${action} institution`
              this.$swal({
                icon: 'error',
                title: `<h4>${errorMessage}</h4>`,
                showConfirmButton: true,
                confirmButtonColor: '#7367f0',
                allowOutsideClick: true,
              })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

[dir] .dark-layout input.form-control,
[dir] .dark-layout .custom-file-label,
[dir] .dark-layout textarea.form-control {
  height: 45px;
  box-shadow: black beige indigo;
  border-radius: 8px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  background: linear-gradient(
    90deg,
    rgba(158, 63, 217, 0.2) 0%,
    rgba(37, 78, 158, 0.2) 49%,
    rgba(70, 124, 227, 0.2) 100%
  );
  border: 2px solid #ffffff3c;
  border-left: none;
  border-right: none;
  border-top: none;
}
[dir] .dark-layout input.form-control:not(:focus),
[dir] .dark-layout .custom-file-label:not(:focus),
[dir] .dark-layout textarea.form-control:not(:focus) {
  border-color: #ffffff3c;
}

.field-icon {
  position: absolute;
  top: 10px;
  left: 30px;
  color: #ffffffcc !important;
  font-weight: 500;
}

/* Status Toggle Styles */
.status-toggle-link {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease;
  padding: 4px;
  border-radius: 4px;
}

.status-toggle-link:hover {
  opacity: 0.8;
}

.status-toggle-link:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.status-active {
  color: #10b981 !important;
}

.status-inactive {
  color: #ef4444 !important;
}

.status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-active-badge {
  background-color: rgba(16, 185, 129, 0.2);
  color: #10b981;
}

.status-inactive-badge {
  background-color: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

/* Status Filter Styles */
#status-filter {
  min-width: 150px;
  height: 45px;
  border-radius: 8px;
  background-color: #121a2b !important;
  border: 1px solid #2a324a !important;
  color: #ffffff !important;
}

#status-filter:focus {
  border-color: #23c7ec !important;
  box-shadow: 0 0 0 2px rgba(35, 199, 236, 0.25) !important;
  outline: none !important;
}

#status-filter option {
  background-color: #121a2b;
  color: #ffffff;
}
</style>
